import Banner from './Banner'
import HealthTeamBannerContainer from './HealthTeamBannerContainer'

export { Banner, HealthTeamBannerContainer }

export default HealthTeamBannerContainer
